import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { BackgroundCard } from './BackgroundCard';
import {
  EmptySearchText,
  EmptySearchWrapper,
} from 'app/pages/admin/landing-pages-v2/styles';
import { useDefaultBackgroundMutation } from 'lib/api/backgrounds/useDefaultBackgroundMutation';
import { IBackgroundResponse } from 'lib/api/backgrounds/useQueryBackgrounds';

interface IBackgroundsListProps {
  backgrounds: IBackgroundResponse[];
  isLoading: boolean;
}

export const BackgroundList = ({
  backgrounds,
  isLoading,
}: IBackgroundsListProps) => {
  const {
    mutateAsync: setDefaultBackgroundMutation,
    isLoading: isSettingDefaultBackgroundMutation,
  } = useDefaultBackgroundMutation();

  const onDefaultBackgroundChange = (backgroundId: number) => {
    setDefaultBackgroundMutation({ id: backgroundId });
  };

  const isProcessing = isLoading || isSettingDefaultBackgroundMutation;

  return (
    <Flex
      width='100%'
      flexDirection='row'
      gap='27px'
      justifyContent='flex-start'
      flexWrap='wrap'
    >
      {isLoading ? (
        <div>
          <LoadingIndicator isLoading={isLoading} />
        </div>
      ) : (
        <>
          {backgrounds.length > 0 ? (
            backgrounds.map(background => (
              <BackgroundCard
                key={background.backgroundId}
                background={background}
                isLoading={isProcessing}
                onDefaultBackgroundChange={onDefaultBackgroundChange}
              />
            ))
          ) : (
            <EmptySearchWrapper>
              <EmptySearchText>
                There are no Backgrounds available.
              </EmptySearchText>
            </EmptySearchWrapper>
          )}
        </>
      )}
    </Flex>
  );
};
